import { storeToRefs } from 'pinia'

import { useAppStore } from '@/stores/app'
import { IEntityTypeDefinition } from '@/types/shared'

export function useLang() {
  const appStore = useAppStore()
  const { language } = storeToRefs(appStore)

  const getValueByLang = (input: Record<string, string> | string): string => {
    if (typeof input !== 'object') {
      return input
    }

    const lang = language.value

    if (Object.prototype.hasOwnProperty.call(input, lang)) {
      return input[lang]
    }

    return input[Object.keys(input)[0]]
  }

  const getAttributeNameByLang = (
    attributeName: string,
    attributeDefinition: IEntityTypeDefinition[typeof attributeName],
  ): string => {
    const lang = language.value

    if (attributeDefinition?.trans?.[lang]) {
      return attributeDefinition.trans[lang]
    }

    return attributeName
  }

  return {
    language,
    getValueByLang,
    getAttributeNameByLang,
  }
}
